<template>
	<view
		class="card"
		:style="{
			background:
				backgroundType == 0
					? 'url(../../../static/image/background/customer-blue.png) no-repeat'
					: backgroundType == 1
					? 'url(../../../static/image/background/huoDai.png) no-repeat'
					: 'url(../../../static/image/background/driver.png) no-repeat',
			backgroundSize: '100% 100%'
		}"
	>
		<!-- <view class="icon" @click="iconClick(name)" v-if="icon"><u-icon name="arrow-rightward"></u-icon></view> -->
		<view class="card-body" @click="bodyClick">
			<view class="card-left"><slot name="left"></slot></view>
			<view class="card-right">
				<view class="card-right-top"><slot name="right-top"></slot></view>
				<view class="card-right-bottom"><slot name="right-bottom"></slot></view>
			</view>
		</view>
	</view>
</template>
<script>
export default {
	name: 'card',
	props: {
		// icon: {
		// 	type: Boolean,
		// 	default: false
		// },
		backgroundType:{
			type:Number,
			default:0
		},
		name: {
			type: String,
			default: ''
		}
	},
	data() {
		return {
		};
	},
	methods: {
		bodyClick() {
			this.$emit('click', this.name);
		}
		// iconClick() {
		// 	this.$emit('iconClick', this.name);
		// }
	}
};
</script>

<style lang="scss" scoped>
.card {
	// padding: vww(7) vww(10) vww(10) vww(10);
	width: 100%;
	height: vww(138);
	// box-shadow: 0px 0px 8px 0px rgba(216, 218, 238, 0.8);
	// padding: vww(15);
	box-sizing: border-box;
	// overflow: hidden;
	// margin-top: vww(12);
	// border-radius: vww(8);
	.icon {
		width: vww(20);
		height: vww(20);
		float: right;
	}
	.card-body {
		font-size: vww(14);
		font-weight: 300;
		width: 100%;
		height: 100%;
		display: flex;
		.card-left {
			width: 40%;
			height: 100%;
		}
		.card-right {
			width: 60%;
			height: 100%;
			&-top {
				width: 100%;
				height: 65%;
			}
			&-bottom {
				width: 100%;
				height: 35%;
			}
		}
	}
}
</style>
